//Proofed
import { AWARDS_NUM, CONTRACT_NUM, REVIEWS_URL, TENDER_NUM } from './common'
import SearchIcon from '@mui/icons-material/Search'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import InsightsIcon from '@mui/icons-material/Insights'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import type { ComponentType } from 'react'
import type { SvgIconProps } from '@mui/material'
import { BORDER_BLACK, COLOR_PRIMARY, COLOR_QUATERNARY, COLOR_SECONDARY, COLOR_TERTIARY, NAVBAR_BG, DARK_700, DARK_800, DARK_900, BG_LIGHT, CHECKCIRCLE_SIZE, BORDER_WHITE } from '../theme'

export const CORE_VIDEO_ID = '678k9sW0O1E'
export const ANALYTICS_VIDEO_ID = 'JiUapAfM5sk'
export const TENDERNINJA_VIDEO_ID = 'V9Bu8TE1o0s'
// Home "Find Tenders" card only - this cut is 4:3, hence the videoAspect override
export const FIND_TENDERS_VIDEO_ID = 'ZKHyP0cq5FY'

export const stats = [
    { value: "", label: 'Live Tenders' },//this is filled in live
    { value: TENDER_NUM, label: 'Tenders in our database' },
    // { value: AWARDS_NUM, label: 'Contract Awards in our database' },
    { value: '40%', label: 'of tenders not published on Find a Tender' },
    { value: '5.0 ★', label: 'Reviews.io rating, 52 reviews, 100% recommend', href: REVIEWS_URL },
]

export const freetrialpoints = ['14-day free trial', 'Cancel anytime']

export const homeStepsTitle = "From setup to winning, four steps to a stronger pipeline.";
export const homeStepSearch = {
    num: '1',
    Icon: SearchIcon,
    title: 'Set Searches',
    body: 'Configure keywords, CPV codes, contract value and region in minutes. CFP monitors every UK & Ireland public sector portal so you don\'t have to',
}

export const homeStepMail = {
    num: '2',
    Icon: MailOutlineIcon,
    title: 'Get Your Daily Digest',
    body: 'One email every morning with your matched opportunities. Flash alerts for time-sensitive tenders. No portal trawling required',
}
export const homeStepQualify = {
    num: '3',
    Icon: InsightsIcon,
    title: 'Qualify Fast',
    body: 'Research buyer history, past awards, competitor wins and framework participation before you commit. Make smarter bid/no-bid decisions',
}



export const homeSteps = [
    homeStepSearch,
    homeStepMail,
    homeStepQualify,
    {
        num: '4',
        Icon: AutoAwesomeIcon,
        title: 'Draft Stronger',
        body: 'Tender Ninja drafts compliant responses using your own documents. Evaluate gaps, reduce word counts and submit with confidence',
    },
]


export interface ProductInfo {
    name: string
    tabLabel: string
    tabSubtitle: string
    tagline: string
    description: string
    path: string
    pricingTab: number
    Icon: ComponentType<SvgIconProps>
    color: string
    features: string[],
    videoid: string
    thumb?: string
    videoAspect?: string // CSS paddingTop for the video box; omit for 16:9
}



export const productCards: ProductInfo[] = [
    {
        name: 'Core',
        tabLabel: 'Find Tenders',
        tabSubtitle: '100% of public sector tenders in one place',
        tagline: 'Tender Alerting',
        description: `Search ${TENDER_NUM} UK & Ireland public sector contracts with personalised daily alerts, flash emails for urgent opportunities and competitive analysis tools all in one place.`,
        path: '/products/core',
        pricingTab: 0,
        Icon: NotificationsActiveIcon,
        color: COLOR_PRIMARY,
        features: ['Tailored daily email alerts', 'Flash emails for urgent tenders', `${TENDER_NUM} live & historical contracts`, 'Buyer behaviour analysis',],
        videoid: FIND_TENDERS_VIDEO_ID,
        videoAspect: '75%',
    },
    {
        name: 'Analytics',
        tabLabel: 'Analyse the Market',
        tabSubtitle: 'Shape a winning public sector strategy',
        tagline: 'Market Intelligence',
        description: 'Forecast the public sector market before your competitors move. Analyse spending patterns, map upcoming renewals and score the opportunities most worth pursuing.',
        path: '/products/analytics',
        pricingTab: 2,
        Icon: InsightsIcon,
        color: COLOR_QUATERNARY,
        features: ['Buyer spend profiling', 'Contract renewal forecasting', 'Competitor award analysis', 'Opportunity scoring'],
        videoid: ANALYTICS_VIDEO_ID
    },
    {
        name: 'Tender Ninja',
        tabLabel: 'Write Bids',
        tabSubtitle: 'Submit more high quality bids',
        tagline: 'Safe AI Bid Writing',
        description: 'Transform your win rate with safe AI proposal writing. Craft compelling, compliant bids faster from your documents.',
        path: '/products/tender-ninja',
        pricingTab: 1,
        Icon: AutoAwesomeIcon,
        color: COLOR_SECONDARY,
        features: ['Responses from your documentation', 'Use storyboards for structure', 'Score your responses', 'Find out what your response is missing'],
        videoid: TENDERNINJA_VIDEO_ID
    },
]






